import { useState } from "react";
import "./CustomItemModal.css";

export default function CustomItemModal({ open, onClose, onAgregar }) {
  const [nombre, setNombre] = useState("");
  const [precio, setPrecio] = useState("");
  const [cantidad, setCantidad] = useState(1);

  if (!open) return null;

  const reset = () => {
    setNombre("");
    setPrecio("");
    setCantidad(1);
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!nombre.trim()) return;
    const p = Number(String(precio).replace(/\./g, "").replace(",", "."));
    if (!p || p <= 0) return;
    const q = Math.max(1, Number(cantidad));
    onAgregar({ nombre: nombre.trim(), precio: p, cantidad: q });
    reset();
    onClose();
  };

  return (
    <div className="ci-modal" onClick={handleClose}>
      <div className="ci-panel" onClick={(e) => e.stopPropagation()}>
        <div className="ci-head">
          <div className="ci-head__left">
            <div className="ci-head__icon">✏️</div>
            <h3 className="ci-title">Ítem personalizado</h3>
          </div>
          <button className="ci-close" onClick={handleClose} aria-label="Cerrar">×</button>
        </div>

        <form className="ci-body" onSubmit={handleSubmit}>
          <div className="ci-field">
            <label htmlFor="ci-nombre">Nombre del producto</label>
            <input
              id="ci-nombre"
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Ej: Empanada extra, Gaseosa…"
              autoFocus
              required
            />
          </div>

          <div className="ci-row">
            <div className="ci-field">
              <label htmlFor="ci-precio">Precio ($)</label>
              <input
                id="ci-precio"
                type="number"
                inputMode="numeric"
                min="0"
                step="1"
                value={precio}
                onChange={(e) => setPrecio(e.target.value)}
                placeholder="0"
                required
              />
            </div>
            <div className="ci-field ci-field--sm">
              <label htmlFor="ci-cantidad">Cantidad</label>
              <input
                id="ci-cantidad"
                type="number"
                inputMode="numeric"
                min="1"
                max="99"
                value={cantidad}
                onChange={(e) => setCantidad(e.target.value)}
              />
            </div>
          </div>

          <div className="ci-footer">
            <button type="button" className="ci-btn ci-btn--cancel" onClick={handleClose}>
              Cancelar
            </button>
            <button
              type="submit"
              className="ci-btn ci-btn--add"
              disabled={!nombre.trim() || !precio || Number(precio) <= 0}
            >
              Agregar al pedido
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
